import Header from "../../components/Header";
import Slider from "../../components/Slider";
import Breadcrumbs from "../../components/Breadcrumbs";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";
import Section from "../Section";

export default function SectionLayout(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "aktualnosci";

	let blog = props.blog;
	let title = props.title;
	let description = props.description;
	let seoTitle = props.seoTitle;
	let seoDescription = props.seoDescription;
	let seoImage = props.seoImage;
	let datePublication = props.datePublication;
	let dateUpdate = props.dateUpdate;
	let hours = props.hours;
	let author = props.author;
	let imageDesktop = props.imageDesktop;
	let imageTablet = props.imageTablet;
	let imageMobile = props.imageMobile;
	let blogWithAction = props.blogWithAction;
	let blogActionText = props.blogActionText;
	let blogActionUrl = props.blogActionUrl;
	let blogMiasto = props.blogMiasto;
	let blogPodatek = props.blogPodatek;

	return (
		<>
			{/* HEAD */}
			<SEO
				blog
				author={author}
				datePublication={datePublication}
				dateUpdate={dateUpdate}
				hours={hours}
				seoTitle={seoTitle}
				seoDescription={seoDescription}
				imagesUrl={seoImage}
			/>

			{/* TOP */}

			<Header miasto={Miasto} />

			<Slider
				miasto={Miasto}
				podatek={Podatek}
				small
				blog
				blogWithAction={blogWithAction}
				blogActionText={blogActionText}
				blogActionUrl={blogActionUrl}
				blogMiasto={blogMiasto}
				blogPodatek={blogPodatek}
				title={title}
				description={description}
				datePublication={datePublication}
				dateUpdate={dateUpdate}
				imageDesktop={imageDesktop}
				imageTablet={imageTablet}
				imageMobile={imageMobile}
				typeHero="slider"
			/>

			<Breadcrumbs miasto={Miasto} layout="light" title={title} />

			{/* SECTION */}

			{props.article ? props.children : <Section>{props.children}</Section>}

			{/* BOTTOM */}

			{/* {!home && (
        <div>
            <a href="/">← Back to home</a>
        </div>
      )} */}

			<Footer miasto={Miasto} />
		</>
	);
}
